<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="开票编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['invoiceNumber',{}]" disabled></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="开票单位" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['invoiceUnit_dictText', {}]" disabled></a-input>
              <!--<a-select-->
                <!--v-decorator="[ 'invoiceUnit', validatorRules.invoiceUnit]"-->
                <!--placeholder="请选择开票单位"-->
                <!--:getPopupContainer = "(target) => target.parentNode">-->
                <!--<a-select-option v-for="(item) in invoiceUnits" :value="item.orgCode">{{item.departName}}</a-select-option>-->
              <!--</a-select>-->
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="申请人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['user_dictText',{}]" placeholder="请输入申请人" disabled></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="申请人部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['userDep_dictText',{}]" :trigger-change="true" dictCode="bms_dep" placeholder="请选择申请人部门" disabled/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['project',{}]" :trigger-change="true" dictCode="bms_project" placeholder="请选择项目名称" disabled/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="业务类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['businessType',{}]" :trigger-change="true" :options="allBusinessTypeDictOptions" placeholder="请选择业务类型" disabled/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="佣金计算方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['brokerageWay',{}]" :trigger-change="true" dictCode="bms_include_tax" placeholder="请选择佣金计算方式" disabled/>
              <!--<a-input v-decorator="['brokerageWay']" placeholder="请输入佣金计算方式"></a-input>-->
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="经纪人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['broker_dictText',{}]" placeholder="请输入经纪人" disabled></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--<j-dict-select-tag type="list" v-decorator="['insuranceDep']" :trigger-change="true" dictCode="bms_dep" placeholder="请选择部门" disabled/>-->
              <a-input v-decorator="['insuranceDep_dictText',{}]" disabled placeholder="请输入部门名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保险公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag type="list"
                                   v-decorator="['companyCode', validatorRules.companyCode]"
                                   :trigger-change="true"
                                   dict="biz_insurance_company,name,code"
                                   @change="changeInsuranceCompany"
                                   placeholder="请选择保险公司"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="购买方名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['consumerName',{}]" placeholder="请输入购买方名称"></a-input>
            </a-form-item>
          </a-col>
<!--          <a-col :span="24">
            <a-form-item label="发票类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['invoiceType',{}]" :trigger-change="true" dictCode="bms_invoice_type" placeholder="请选择发票类型"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="购买方纳税人识别号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['consumerIdentification',{}]" placeholder="请输入购买方纳税人识别号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="购买方地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['consumerAddress',{}]" placeholder="请输入购买方地址"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="购买方电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['consumerPhone',{}]" placeholder="请输入电话"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="购买方开户行" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['consumerBankName',{}]" placeholder="请输入购买方开户行"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="购买方开户行账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['consumerBankNumber',{}]" placeholder="请输入购买方开户行账号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="发票开具内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['invoiceContent',{}]" :trigger-change="true" dictCode="bms_invoice_content" placeholder="请选择发票开具内容"/>
              &lt;!&ndash; <a-input v-decorator="['invoiceContent',{}]" placeholder="请输入发票开具内容"></a-input> &ndash;&gt;
            </a-form-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-item label="保费(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['rate',{}]" :formatter="moneyFormatter" placeholder="请输入保费" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="净保费(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['cleanPremium',{}]" :formatter="moneyFormatter" placeholder="请输入净保费" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="金额(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['money',{}]" :formatter="moneyFormatter" placeholder="请输入金额" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['ps',{}]" placeholder="请输入备注"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['status',{}]" :trigger-change="true" dictCode="bms_invoice_status" placeholder="请选择状态" disabled/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="发票号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['invoicePaperCode',{}]" disabled/>
            </a-form-item>
          </a-col>

          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue,moneyFormatter } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from '../../../components/dict/JSearchSelectTag'
  import { AllBusinessTypeDictOptions } from '../../enums/businessTypeDictOptions'

  export default {
    name: 'BizInvoiceinfoForm1',
    components: {
      JSearchSelectTag,
      JFormContainer,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        allBusinessTypeDictOptions:[],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          companyCode: {
            rules: [
              { required: true, message: '请选择保险公司' }
            ]
          },
        },
        url: {
          add: "/bms/bizInvoiceinfo/add",
          edit: "/bms/bizInvoiceinfo/edit",
          queryById: "/bms/bizInvoiceinfo/queryById",
          getCompanyInvoiceConfig:'/bms/insuranceCompanyInvoice/getCompanyInvoiceInfo',
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      this.allBusinessTypeDictOptions = AllBusinessTypeDictOptions
    },
    methods: {
      moneyFormatter,
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'invoiceNumber','user', 'user_dictText','userDep','userDep_dictText','project','businessType','brokerageWay','insuranceDep','insuranceDep_dictText', 'broker','broker_dictText', 'companyCode', 'invoiceType','consumerName','consumerIdentification','consumerAddress','consumerPhone','consumerBankName','consumerBankNumber','invoiceContent','rate','money','tax','sumPriceTax','insuranceCompanyInfo','ps','status','period','invoiceUnit','invoiceUnit_dictText','invoicePaperCode'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      // 保险公司改变
      changeInsuranceCompany(value){
        let param = {companyCode: value}
        getAction(this.url.getCompanyInvoiceConfig, param).then((res) =>{
          if(res.success){
            this.form.setFieldsValue({
              companyCode: res.result.companyCode,
              invoiceType: res.result.invoiceType,
              consumerName: res.result.consumerName,
              consumerIdentification: res.result.consumerIdentification,
              consumerAddress: res.result.consumerAddress,
              consumerPhone: res.result.consumerPhone,
              consumerBankName: res.result.consumerBankName,
              consumerBankNumber: res.result.consumerBankNumber
            });
          }
        })
      },

      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }

            let formData = Object.assign(this.model, values);
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'invoiceNumber','user','user_dictText','userDep','userDep_dictText','project','businessType','brokerageWay','insuranceDep','insuranceDep_dictText', 'broker','broker_dictText','invoiceType','companyCode','consumerName','consumerIdentification','consumerAddress','consumerPhone','consumerBankName','consumerBankNumber','invoiceContent','rate','money','tax','sumPriceTax','insuranceCompanyInfo','ps','status','period','invoiceUnit','invoiceUnit_dictText','invoicePaperCode'))
      },
    }
  }
</script>